import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import es from './es.json';

const detectInitialLanguage = () => {
    if (typeof window === 'undefined') {
        return 'en';
    }

    const storedLanguage = window.localStorage.getItem('appLanguage');
    if (storedLanguage) {
        return storedLanguage;
    }

    const browserLanguage = window.navigator.language?.split('-')[0];
    if (browserLanguage && ['en', 'es'].includes(browserLanguage)) {
        return browserLanguage;
    }

    return 'en';
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es }
        },
        lng: detectInitialLanguage(),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

i18n.on('languageChanged', (lng) => {
    if (typeof window !== 'undefined') {
        window.localStorage.setItem('appLanguage', lng);
    }
});

export default i18n;


